































import {Component, Mixins} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import DeliveryAuditRequest from '@/model/request/DeliveryAuditRequest'
import FilterDeliveryAudit from '@/components/filters/FilterDeliveryAudit.vue'
import DeliveryAuditResponse from '@/model/response/DeliveryAuditResponse'
import {snakeCase} from 'lodash'
import {AppConfig} from '@/config/app.config'
import * as Helper from '@/helpers'
import FilterToggle from '@/components/FilterToggle.vue'
import moment from 'moment'

const metaInfo = () => ({
  title: $.t('view.reports.deliveryAudit.title'),
})

@Component({
  metaInfo,
  components: {FilterDeliveryAudit, FilterToggle},
})
export default class ReportsDeliveryAuditView extends Mixins(MixinFilter) {
  filter = new DeliveryAuditRequest()
  collection = new PageCollection(DeliveryAuditResponse, this.filter, 10)

  AppConfig = AppConfig

  created() {
    if (this.$route.query.from === undefined) {
      this.filter.fromDate = moment().startOf('month').format()
    }

    if (this.$route.query.to === undefined) {
      this.filter.toDate = moment().endOf('month').format()
    }
  }

async downloadData(xlsx: boolean) {
  const reportEndpoint = '/user/indicador/auditoria-por-geoposicionamento/csv'

  if (!xlsx) {
      const csv = new PageCollection(DeliveryAuditResponse, this.filter, null, null)
      csv.endpoint = reportEndpoint
      const fetch = async () => await csv.search()
      await $.await.run(fetch, 'download')
      csv.downloadCsv(snakeCase($.t('view.reports.deliveryAudit.title')))
  } else {
      await $.await.run(() => Helper.downloadXlsx(
        $.t('view.reports.deliveryAudit.title'),
        reportEndpoint,
        this.filter,
        DeliveryAuditResponse,
        'DeliveryAuditResponse',
        ), 'download')
  }
}
}
